import React, {useState} from "react";
import "./OpenView.css";
import Form from "react-bootstrap/Form";
import {Button} from "react-bootstrap";
import {useFormikContext} from "formik";
import {useEditContext} from "./EditContext";

const OpenView = () => {
  const {resetForm, setValues} = useFormikContext();
  const {setEditNode, savedMaps, savedMapsLoading, savedMapsError} =
    useEditContext();
  const [selectedMapId, setSelectedMapId] = useState<string>("");

  return (
    <div className="OpenView">
      <div className="OpenView-load">
        <Button
          variant="secondary"
          onClick={() => {
            if (
              window.confirm(
                "Are you sure you want to load this map? Current progress will be lost.",
              )
            ) {
              setValues(savedMaps.find(map => map.id === selectedMapId));
              setEditNode(null);
            }
          }}>
          Load from ID
        </Button>
        {savedMapsError ? (
          <div>Failed to load saved maps.</div>
        ) : (
          <Form.Select
            disabled={savedMapsLoading}
            value={selectedMapId}
            onChange={ev => {
              setSelectedMapId(ev.target.value);
            }}>
            <option value="">{savedMapsLoading ? "Loading..." : ""}</option>
            {savedMaps.map(savedMap => (
              <option key={savedMap.id} value={savedMap.id}>
                {savedMap.name}
              </option>
            ))}
          </Form.Select>
        )}
      </div>
      <div>
        <Button
          variant="secondary"
          onClick={() => {
            if (
              window.confirm(
                "Are you sure you want to create a new map? Current progress will be lost.",
              )
            ) {
              resetForm();
              setEditNode(null);
            }
          }}>
          Create New
        </Button>
      </div>
    </div>
  );
};

export default OpenView;
